<cosmos-section
  class="cosmos-cluster-summary__section"
>
  <cosmos-expandable-panel
    [accordionItems]="_accordionData"
    [numberOfColumns]="3"
    [hasImage]="true"
    panelTitle="Cluster Details"
  ></cosmos-expandable-panel>
</cosmos-section>

<ng-template #isFeaturedSlider>
  <div
    *ngIf="isFeatured"
    class="cosmos-cluster-summary__information-wrapper"
  >
    <span class="cosmos-cluster-summary__label">Is Featured: </span>
    <mat-slide-toggle [formControl]="isFeatured"></mat-slide-toggle>
  </div>
</ng-template>

<ng-template
  #image
  *ngIf="!_cluster?.isPrivate"
>
  <div class="cosmos-cluster-summary__image-wrapper">
    <cosmos-image
      *ngIf="_cluster.coverImageUrl"
      [src]="_cluster.coverImageUrl"
      class="cosmos-cluster-summary__image-wrapper__image"
    ></cosmos-image>
  </div>
</ng-template>
